import actions from "./actions";

import {
  errorMutations,
  loadingMutations,
  resetErrorsAndLoading,
  setter,
  getter,
  metadataSetter,
  replaceOrSetArrayObjectsValue
} from "@/store/utils";

import {
  CREATE_LETTER_TEMPLATE,
  FETCH_LETTERS_TEMPLATES_LIST,
  DELETE_LETTER_TEMPLATE,
  RETRIEVE_LETTER_TEMPLATE,
  UPDATE_LETTER_TEMPLATE,
  FETCH_PRODUCT_CODES_LIST
} from "./types";
import { sortSearchPaginateMutationsNewFormat } from "@/store/common/mutations";
import { paginationFilterSortGetters } from "@/store/common/getters";
import { paginationFilterSortInitialObject } from "@/store/constants";

const state = {
  isLoading: false,
  errors: null,
  productCodesList: [],
  templatesList: [],
  ...paginationFilterSortInitialObject
};

const getters = {
  getTemplate: state => id =>
    state.templatesList.filter(temp => temp.id === id)[0],
  isLoading: getter("isLoading"),
  historyList: getter("historyList"),
  templatesList: getter("templatesList"),
  productCodesList: getter("productCodesList"),
  ...paginationFilterSortGetters
};

const mutations = {
  [FETCH_PRODUCT_CODES_LIST.success](state, { payload }) {
    setter("productCodesList", payload)(state);
    resetErrorsAndLoading(state);
  },

  [FETCH_LETTERS_TEMPLATES_LIST.success](state, { payload }) {
    setter("templatesList", payload.items)(state);
    metadataSetter(payload, state, ["pagination", "sort", "filters"]);
    resetErrorsAndLoading(state);
  },

  [CREATE_LETTER_TEMPLATE.success](state, { payload }) {
    state.templatesList.push(payload);
    resetErrorsAndLoading(state);
  },

  [DELETE_LETTER_TEMPLATE.success](state, { payload }) {
    const updList = state.templatesList.filter(item => item.id !== payload);
    setter("templatesList", updList)(state);
    resetErrorsAndLoading(state);
  },

  [UPDATE_LETTER_TEMPLATE.success](state, { payload }) {
    replaceOrSetArrayObjectsValue(
      state,
      "templatesList",
      "id",
      payload.id,
      payload
    );
    resetErrorsAndLoading(state);
  },

  [RETRIEVE_LETTER_TEMPLATE.success](state, { payload }) {
    replaceOrSetArrayObjectsValue(
      state,
      "templatesList",
      "id",
      payload.id,
      payload
    );
    resetErrorsAndLoading(state);
  },

  ...loadingMutations([
    FETCH_LETTERS_TEMPLATES_LIST.request,
    CREATE_LETTER_TEMPLATE.request,
    DELETE_LETTER_TEMPLATE.request,
    RETRIEVE_LETTER_TEMPLATE.request,
    UPDATE_LETTER_TEMPLATE.request
  ]),

  ...errorMutations([
    FETCH_LETTERS_TEMPLATES_LIST.error,
    CREATE_LETTER_TEMPLATE.error,
    DELETE_LETTER_TEMPLATE.error,
    RETRIEVE_LETTER_TEMPLATE.error,
    UPDATE_LETTER_TEMPLATE.error
  ]),

  ...sortSearchPaginateMutationsNewFormat
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
